export const PREFIX_REMOVE_FLAG_ID = 'issue-actions-remove-flag-issue-';
export const PREFIX_ADD_FLAG_ID = 'issue-actions-add-flag-issue-';
export const FLAG_MODAL_SOURCE = 'command-palette';
